import { css } from '@emotion/css';
import {
  N0,
  N50,
  N200,
  N700,
  N900,
  R500,
  R200,
  Y500,
  primary,
  primaryDark,
  darkBlue,
} from '@assets/colors';

const configStyleSize = {
  xs: 'font-size: 12px; padding: 4px 8px;',
  sm: 'font-size: 14px; padding: 8px 16px;',
  md: 'font-size: 17px; padding: 11px 16px;',
};

const configIconSize = {
  xs: 'height: 12px;',
  sm: 'height: 16px;',
  md: 'height: 20px;',
};

const configStyleVariant = {
  primary: `
    min-width: 82px;
    color: ${N0};
    background-color: ${primary};
    border: solid 1px ${primary};

    :hover,
    :visited,
    :active,
    :focus {
      background-color: ${darkBlue};
      outline: none;
    }

    :disabled {
      background-color: ${N50};
      border: solid 1px ${N50};
    }
  `,
  secondary: `
    min-width: 82px;
    color: ${primary};
    background-color: ${N0};
    border: solid 1px ${primary};

    :hover,
    :visited,
    :active,
    :focus {
      color: ${primary};
      background-color: ${N50};
      outline: none;
    }

    :disabled {
      background-color: ${N0};
      border: solid 1px ${N200};
    }
  `,
  tertiary: `
    min-width: 82px;
    color: ${N700};
    background-color: ${N0};
    border: solid 1px ${N200};

    :hover,
    :visited,
    :active,
    :focus {
      color: ${N700};
      background-color: ${N50};
      outline: none;
    }

    :disabled {
      background-color: ${N0};
      border: solid 1px ${N200};
    }
  `,
  quartenary: `
  min-width: 82px;
    color: ${primary};
    background-color: ${N0};

    :hover,
    :visited,
    :active,
    :focus {
      color: ${primary};
      background-color: ${N50};
      outline: none;
    }

    :disabled {
      background-color: ${N0};
    }
  `,
  danger: `
    min-width: 82px;
    color: ${N0};
    background-color: ${R500};

    :hover,
    :visited,
    :active,
    :focus {
      background-color: ${R200};
      outline: none;
    }

    :disabled {
      background-color: ${N50};
    }
  `,
  topup: `
    color: ${primaryDark};
    background-color: ${Y500};
  `,
  'grey-outlined': `
    color: ${N900};
    background-color: ${N0};
    border-radius: 4px !important;
    outline: 1px solid ${N200} !important;
    box-shadow: none !important;


    :focus {
      outline: 1px solid ${N200};
    }
  `,
};

export const styBtn = props => css`
  cursor: pointer;
  font-weight: bold;
  text-align: center;
  box-shadow: none;
  border: none;
  outline: none;
  letter-spacing: 0.05em;
  white-space: nowrap;
  vertical-align: middle;
  align-items: center;
  border-radius: 8px;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

  ${configStyleSize[props.size]}
  ${configStyleVariant[props.variant]}

  ${props.fluid && 'width: 100%;'}
  ${props.hadIcon && 'display:flex;'}
  ${props.iconPosition === 'right' && 'img, svg { margin-left: 8px; }'}

  :disabled {
    cursor: not-allowed;
    color: ${N200};

    :hover,
    :visited,
    :active,
    :focus {
      text-decoration: none;
      outline: none;
    }
  }
`;

export const styBtnIcon = props => css`
  display: flex;
  ${configIconSize[props.size]}
  vertical-align: text-bottom;
  align-items: center;
  ${props.iconPosition === 'left'
    ? 'margin-right: 8px;'
    : 'margin-left: auto;'}
`;
